import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, Switch, Route, useHistory } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';
import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';

// Types
import Period from "../../../types/Period";
import LoginTags from "../../../types/LoginsTags";
import LoginsDataTable from "../../../types/LoginsDataTable";

// Views.
import List from './List';
import Detail from './Detail';
import Breadcrumb from "../../../container/breadcrumb";
import HeaderActions from "../../../container/header_actions";

// Constants
import { ACTIONS } from "../../../component/Constants";

// Api
import LoginApi from "../../../api/LoginApi";

// DayJS plugins - note, the position of these in this file are important.
dayjs.extend(isoWeek.default);

function Logins(props: { toggleMenu: Function, period: Period, applyPeriod: Function, loginRequired: boolean }) {
    const [logins, setLogins] = useState<LoginsDataTable[]>([]);
    const [assignedTags, setAssignedTags] = useState<LoginTags[]>([]);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const history = useHistory();

    useEffect(() => {
        if (!props.loginRequired) {
            history.push(`/not-found`)
        }
    }, [props.loginRequired]);

    useEffect(() => {
        void getLogins();
        void getTags();

    }, []);

    useEffect(() => {
        const savedToken = window.localStorage.getItem('dbmar-token');
        if (savedToken) {
            const decodedToken = atob(savedToken).split(':')
            const username = decodedToken[0]
            const findUser: any = logins.find(user => user.name === username)
            if (findUser) {
                setIsAdmin(findUser.admin)
            }
        }
    }, [logins]);

    const getLogins = async() => {

        // Get Logins
        let logins: LoginsDataTable[] = await LoginApi.getLogins()

        setLoading(false)
        setLogins(logins)
    }

    const getTags = async() => {

        let loginTags: any[] = await LoginApi.getTags();
        setLoading(false)
        setAssignedTags(loginTags)
    }

    const refresh = () => {
        setLogins([])
        setAssignedTags([])
        setLoading(true)
        void getLogins();
        void getTags();
    }

    return (
        <div id="content">
            <Helmet>
                <title>Logins - Settings - DBmarlin</title>
                <meta name="description" content="Manage nogins"/>
            </Helmet>

            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                <Breadcrumb heading="Logins">
                    <Link to="/admin">Settings</Link>
                    <span>Logins</span>
                </Breadcrumb>
                <HeaderActions period={props.period} toggleMenu={props.toggleMenu} refresh={() => refresh()}/>
            </div>

            <div className="row row-cols-1">
                <Switch>
                    <Route exact path="/admin/logins/:actionId/:loginId"
                           render={(props: any) => <Detail refresh={refresh} tags={assignedTags} logins={logins}
                                                           actionId={props.match.params.actionId}
                                                           loginId={Number(props.match.params.loginId)}/>}/>
                    <Route exact path="/admin/logins/create"
                           render={(props: any) => <Detail refresh={refresh} {...props} tags={assignedTags} logins={logins}
                                                           actionId={ACTIONS.CREATE.type}
                                                           loginId={Number(props.match.params.loginId)}/>}/>
                    <Route exact path="/admin/logins/"
                           render={(props) => <List {...props} loading={loading} isAdmin={isAdmin} loginDataTable={logins}
                                                    tags={assignedTags}/>}/>
                </Switch>
            </div>
        </div>
    );
}

Logins.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired
};

export default Logins;
